import React from "react"
import { Card, Grid, Icon } from "semantic-ui-react"
import { NavLink } from "react-router-dom"

const SEPPlanCard = ({
  id,
  name,
  type,
  label,
  ownerName,
  employerName,
  contribution_rate
}) => {
  return (
    <Card>
      <Card.Content>
        <Grid style={{ position: "relative", height: "170px" }}>
          <Grid.Row columns={2} verticalAlign="top">
            <Grid.Column>
              <NavLink
                to={`/organize/income+benefits/benefits/${id}/${type.toLowerCase()}`}
                className="navlink"
              >
                <span className="GenericCard__LinkTitle">
                  {label}
                  <Icon name="chevron right" size="small" />
                </span>
                <p className="greyed-text">
                  {employerName && `Sponsored by ${employerName}`}
                </p>
              </NavLink>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <p className="GenericCard__Balance">{contribution_rate}%</p>
              <p className="greyed-text">{"of salary"}</p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2} verticalAlign="bottom">
            <Grid.Column>
              <p className="greyed-text">{ownerName}</p>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <p className="greyed-text">Retirement Plan</p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  )
}

export default SEPPlanCard
